<template>
  <section
    :class="[
      'white-cards',
      { 'article-list': isList },
      { 'white-cards--festival-year-home': isFestivalYearHomePath },
    ]"
  >
    <div class="white-card" v-for="(card, index) in cards" :key="index">
      <router-link
        :to="{ name: routerTo.name, params: { articleId: card.id } }"
        :title="`[前往]${card.title}`"
      >
        <div class="white-card__cover">
          <img
            class="white-card__cover-image"
            style="opacity: 1;"
            :src="getFestivalYearImage(card.cover_image_url)"
            :alt="''"
          />
          <noscript>
            <img
              class="white-card__cover-image"
              style="opacity: 1;"
              :src="card.cover_image_url"
              :alt="''"
            />
          </noscript>
        </div>
        <div class="white-card__date" v-if="card.start_date || card.updated_at">
          <!-- <font-awesome-icon :icon="['fas', 'clock']" /> -->
          <img :src="timeIcon" :alt="''" />
          <span v-if="isFestivalInformationList">{{
            getOnlyDate(card.updated_at)
          }}</span>
          <span v-else>{{
            getFestivalYearDate(card.start_date, card.end_date)
          }}</span>
        </div>
        <h2
          :class="[
            'white-card__title',
            { 'white-card__title--non-height': !hasCategory },
          ]"
          >{{ card.title }}</h2
        >
        <div class="white-card__category" v-if="card.activity_feature">{{
          card.activity_feature
        }}</div>
      </router-link>
    </div>
  </section>
</template>

<script>
import festivalYearDefaultImage from '@/assets/images/festival-year/festival-year-default.png';
import timeIcon from '@/assets/images/festival-year/ic_time.svg';
export default {
  name: 'WhiteCards',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    isList: {
      type: Boolean,
      default: false,
    },
    hasCategory: {
      type: Boolean,
      default: true,
    },
    routerTo: {
      type: Object,
      default: () => {
        return { name: '' };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    festivalYearDefaultImage() {
      return festivalYearDefaultImage;
    },
    isFestivalInformationList() {
      return (
        this.routerTo.name === 'festivalYearNews' ||
        this.routerTo.name === 'festivalYearEnglish' ||
        this.routerTo.name === 'festivalYearInformation'
      );
    },
    timeIcon() {
      return timeIcon;
    },
    isFestivalYearHomePath() {
      return this.$route.path === '/festival-year';
    },
  },
  methods: {
    getFestivalYearImage(imageURL) {
      return imageURL || this.festivalYearDefaultImage;
    },
    getOnlyDate(date) {
      return date.split(' ')[0];
    },
    getFestivalYearDate(startDate, endDate) {
      if (startDate && endDate) {
        return `${startDate}(${this.getDay(
          startDate
        )})～${endDate}(${this.getDay(endDate)})`;
      }

      return `${startDate}(${this.getDay(startDate)})`;
    },
    getDay(date) {
      const dayList = ['日', '一', '二', '三', '四', '五', '六'];

      const theDay = new Date(date).getDay();

      return dayList[theDay];
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.white-card {
  flex: 0 0 auto;
  width: 270px;
  margin-right: 20px;
  text-align: left;
  position: relative;
  height: 330px;
  border-bottom: 1px solid $color-light-border;

  @include for-tablet {
    width: 300px;
    height: 350px;
    margin-bottom: 40px;
  }

  @include for-desktop {
    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  &s {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 16px;
    width: 100%;

    @include for-tablet {
      max-width: 700px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: auto;
    }

    @include for-desktop {
      max-width: 991px;
    }

    &--festival-year-home {
      @include for-tablet {
        max-width: 652px;
      }
      @include for-desktop {
        max-width: 991px;
      }
      .white-card {
        @include for-tablet {
          &:nth-child(2n) {
            margin-right: 0;
          }
        }
        @include for-desktop {
          &:nth-child(2n) {
            margin-right: 19px;
          }
        }
      }
    }
  }

  &__cover {
    position: relative;

    @include for-tablet {
      width: auto;
    }

    &-image {
      border-radius: 5px;
      height: 190px;
      min-height: 190px;
      width: 100%;
      object-fit: cover;
      object-position: top;
      opacity: 0;
      transition: opacity 600ms ease-in;

      @include for-tablet {
        border-radius: 8px;
        height: 210px;
        min-height: 210px;
      }
    }

    h2 {
      position: relative; /* 為了不被卡片陰影遮住 */
      text-align: center;
      font-size: 1.25rem;
      margin: 0 auto 25px;
      box-shadow: 0 6px 15px 20px $color-bg;
      background: $color-bg;
      width: 300px;

      @include for-tablet {
        box-shadow: 0 6px 20px 20px $color-bg, 0 -15px 25px 30px $color-bg;
        width: 100%;
      }
    }
  }

  &__date {
    font-size: 0.875rem;
    margin-top: 10px;
    margin-bottom: 5px;
    line-height: 1.25;
    color: $color-light-text;
    letter-spacing: 0.78px;

    @include for-desktop {
      letter-spacing: 0.89px;
    }

    > img {
      font-size: 1rem;
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }

    img,
    span {
      vertical-align: middle;
    }
  }

  &__title {
    font-size: 1.375rem;
    color: $color-light-link;
    margin: 0;
    line-height: 1.25;
    margin-bottom: 20px;
    letter-spacing: 1.22px;
    @include truncate-multiple-lines(2, 100%);
  }

  &__category {
    padding-bottom: 10px;
    width: 100%;
    font-size: 1rem;
    color: $color-light-text;
    letter-spacing: 0.89px;
    @include truncate-string(100%);
    @include for-tablet {
      position: absolute;
      left: 0;
      bottom: 0;
      background: #fff;
      padding-top: 8px;
    }
  }
}

.article-list {
  display: block;

  @include for-tablet {
    display: flex;
  }

  .white-card {
    margin: 0 auto 30px;
    height: auto;

    &__title {
      padding-top: 5px;
      margin-bottom: 15px;

      @include for-tablet {
        height: 5.5rem;
        margin-bottom: 10px;
      }

      &--non-height {
        height: auto;
        @include for-tablet {
          height: 60px;
        }
      }
    }
  }

  @include for-desktop {
    display: flex;
    max-width: 1000px;
    justify-content: flex-start;

    .white-card {
      margin-bottom: 40px;

      &:nth-child(n + 2) {
        margin-left: 15px;
      }

      &:nth-child(3n + 4) {
        margin-left: 0;
        @include for-tablet-horizontal {
          margin-left: 10px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
